export default function(value) {
  return value.map(({ url }) => url).join("\n");
}
